import React, { useEffect, useState } from 'react';
import { endpoints, getMenuData, POST } from '../../services/modulesServices/userManagement.api';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getNavigateTo } from '../../utils/utils';
import { setUser } from '../../redux/authSlice';
import StatusAlertPopup from '../../components/moduleCommonFormik/StatusAlertPopup';
import { cross, warning } from '../../utils/Logo';
import { useTranslation } from 'react-i18next';
import Loading from '../../components/portalComponents/Loading.component';

export const UserAuthPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modalDetails, setModalDetails] = useState<any>({});
    const [isLoading, setIsLoading] = useState<any>(false);

    const panNumber = searchParams.get('panNumber');
    const goaOnlineAuthSecretKey = searchParams.get('goaOnlineAuthSecretKey');

    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                const { data }: any = await POST(endpoints.goaOnlineUserAuthInitiate + `?panNumber=${panNumber}&goaOnlineAuthSecretKey=${goaOnlineAuthSecretKey}`, {});
                if (data.errorMessage) {
                    setModalDetails({ show: true, title: 'Error!', para: data.errorMessage, img: cross, type: 'error', reUpload: 'OK' });
                } else if (data.loginResponse) {
                    let res = data.loginResponse;
                    //set login details and navigate to data.navUrl
                    localStorage.setItem('token', JSON.stringify(res.access_token));
                    localStorage.setItem('type', JSON.stringify(res.UserRequest.type));
                    localStorage.setItem('user', JSON.stringify(res.UserRequest));
                    dispatch(setUser(res));
                    setIsLoading(false);
                    const authenticatedUserMenu = await getMenuData();
                    redirectTo(authenticatedUserMenu, res.UserRequest.type, data.navUrl);
                } else if (data.entityId) {
                    // registration
                    navigate(`/goa-idc/usermanagement/enterprisecreation?entityId=${data.entityId}`);
                }
                setIsLoading(false);
            } catch (e: any) {
                setIsLoading(false);
                console.log(e);
                setModalDetails({ show: true, title: 'Error!', para: e?.response?.data?.errorMessage, img: cross, type: 'error', reUpload: 'OK' });
            }
        })();
    }, []);

    const redirectTo = (authenticatedUserMenu: any, userType: any, path: string) => {
        const validMenu = authenticatedUserMenu.data?.validMenu;
        const isValid = Object.values(validMenu).some((val: any) => val === path);
        const routeTo = getNavigateTo(userType);

        if (path && !isValid) {
            setModalDetails({
                show: true,
                title: t('UNAUTHORIZED_ACTION', 'Unauthorized Action'),
                para: t('AUTHORIZATION_FAILED', 'Your account lack the necessary authorization to access this particular information.'),
                img: cross,
                type: 'error',
                reUpload: 'Go to Dashboard'
            });
        } else if (path && isValid) {
            navigate(path);
        } else navigate(routeTo);
    };

    const handleModalClose = () => {
        setModalDetails({ show: false });
        navigate('/goa-idc');
    };

    return (
        <div>
            {/* {isLoading ? <Loading /> : ''} */}
            <StatusAlertPopup
                title={modalDetails.title}
                para={modalDetails.para}
                img={modalDetails.img}
                show={modalDetails.show}
                handleClose={() => handleModalClose()}
                type={modalDetails.type}
                reUpload={modalDetails.reUpload}
                handleSubmit={() => handleModalClose()}
            />
        </div>
    );
};
